import { StyleFunction } from 'ol/style/Style.js';
import { Style } from 'ol/style.js';

export type OlMapStyleType = Style | Style[] | StyleFunction;
